<script lang="ts">
  import { appStore } from "$app/store.svelte"

  interface Props {
    course_progress: CourseProgressType
  }

  let { course_progress }: Props = $props()

  let step_content = course_progress.step_data.content
</script>

{#if step_content == "introduction"}
  <div class="px-12">
    <p class="text-center text-3xl text-bold">Welcome!</p>

    <p class="mt-6 text-lg">
      Congratulations on starting the <b>Developing Decision Makers Course</b> which
      distills Marc Koehler's 30+ years as an Officer in the US Nuclear Submarine
      and Turnaround CEO, coaching and mentoring thousands of leaders and employees
      to reach their greatest potential.
    </p>
    <p class="mt-6 text-lg">
      This 7-Part Course teaches you the process to successfully push decision
      making deep into your organization and employees. Includes three
      checklists to empower you and your employees.
    </p>
    <p class="mt-6 text-lg">
      Just follow the step-by-step approach outlined in this online course to
      access all of the valuable videos, guides, instructional materials, and
      examples.
    </p>

    <p class="mt-6 text-lg font-bold">You can do this!</p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/881883516"
        class="absolute inset-0 w-full h-full"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E5 Course"
      ></iframe>
    </div>
  </div>
{:else if step_content == "wrap_up"}
  <div class="px-12">
    <p class="text-center text-3xl text-bold">
      Congratulations on completing the Developing Decision Makers Course!
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/881884373"
        class="absolute inset-0 w-full h-full"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E5 Course"
      ></iframe>
    </div>
  </div>

  <div class="mx-auto w-full flex justify-center my-8">
    <a
      href="/plans/{appStore.plan.id}/courses"
      class="btn btn-rounded success btn-big">VIEW COURSE LIBRARY</a
    >
  </div>
{/if}
